module.exports = __webpack_public_path__ + "static/media/proj17_img3.f4f93a33.jpg";